import { useCallback, useState } from "react";

export type Theme = "dark" | "light";

// The initial value is set on <html data-theme> by the inline script in
// index.html (persisted choice, else OS preference) — read it back here.
export function useTheme(): { theme: Theme; toggle: () => void } {
  const [theme, setTheme] = useState<Theme>(
    () => (document.documentElement.dataset.theme === "light" ? "light" : "dark"),
  );

  const toggle = useCallback(() => {
    setTheme((prev) => {
      const next: Theme = prev === "dark" ? "light" : "dark";
      document.documentElement.dataset.theme = next;
      localStorage.setItem("studio-theme", next);
      return next;
    });
  }, []);

  return { theme, toggle };
}
